export const getSmallestPackagePrice = config =>
    Object.values(config).reduce((acc, { price }) => Math.min(acc, Number(price)), Infinity);
